import axios from '@/utils/axios';
import { useToast } from 'vue-toastification';

const toast = useToast();

 export const projectUtils = {
  
  calculateProgress(completed, total) {
   if (!total || total === 0) return 0;
   return Math.round((completed / total) * 100);
  },

  visibleTo(auth, created_by, clientAdmin){ 
   if(auth?.id === created_by?.id || auth?.id === clientAdmin.id){
    return true;
   } 
   return false;
  },

  async projectPipelines(){
   try{
    const response = await axios.get(`/project-pipelines`);
    return response.data.data; 
   }catch(error){
    this.toast.error(error.message);
   }
  },

  async saveProjectTaskStatus(task_id, status){
   try{
    const payload = {
     status
    }; 
    const response = await axios.patch(`/projects/tasks/${task_id}/update-status`, payload);
    return response.data.data;
   }catch(error){
    this.toast.error(error.message); 
   }
  },


 };